import React, { Component } from "react";
import PropTypes from "prop-types";
import qs from "query-string";

import Page from "../shared/Page";
import * as localStorageHelpers from "../../helpers/localStorage";

class RedirectPage extends Component {
	componentDidMount() {
		const values = qs.parse(this.props.location.search); // code, state

		// we will have the pages form kick off the redux actions to save everything instead
		localStorageHelpers.addDataToObject("verris:redirectValues", values);

		// redirect to where we came from
		let redirectLocation = localStorage.getItem("verris:redirectTo");
		localStorage.removeItem("verris:redirectTo");

		if (!redirectLocation) {
			redirectLocation =
				process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://app.verrisapp.com/";
		}
		window.location.href = redirectLocation;
	}
	render() {
		return <Page title="Redirect" />;
	}
}

RedirectPage.propTypes = {
	location: PropTypes.object,
};

export default RedirectPage;
